import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { CredentialsValidationService } from 'common/data';

class CredentialsValidationStore extends BaseStore {
	constructor(rootStore) {
		super(new CredentialsValidationService(rootStore.app.baasic.apiClient));
	}

	@action
	validateChannel = async channel => {
		let response = await this.service.validateChannel(channel);
		return response.data;
	};

	@action
	validateCarrier = async carrier => {
		let response = await this.service.validateCarrier(carrier);
		return response.data;
	};
}

export default CredentialsValidationStore;
